import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { DESKTOP_BREAKPOINT } from '../../../constans/responsive-break-points';
import { useStore } from '../../../store/store-provider';
import ImageLoadContainer, { IHTMLAttributes } from '../../shared/image-load-container/image-load-container';
import PresenterMobileSlideView from './presenter-mobile-slide-view/presenter-mobile-slide-view';

const PresenterSlideView: FC = (): JSX.Element => {
  const { slideManagementStore, podiumInfoStore } = useStore();
  const { getSlideManagementEntity } = slideManagementStore;
  const { getActivePointer } = getSlideManagementEntity();
  const { isResolutionBreakPointActive } = podiumInfoStore;

  const additionalIndex = 1;
  const imageCls = 'presenter-slide-carousel__current-slide';
  const isMobile: boolean = isResolutionBreakPointActive(DESKTOP_BREAKPOINT);
  const attributes: IHTMLAttributes = {
    'aria-labelledby': `Slide ${getActivePointer().getCurrentCuePointIndex() + additionalIndex}`,
    'alt': '',
    'role': 'img'
  };

  return (
    <div className="presenter-slide-carousel__wrapper">
      {isMobile
        ? <PresenterMobileSlideView
          imageSource={getActivePointer().getSmallThumbnail()}
          attributes={attributes}
          className={imageCls}
          />
        : <ImageLoadContainer
          imageSource={getActivePointer().getLargeThumbnail()}
          attributes={attributes}
          className={imageCls}
          />}
    </div>
  );
};

export default observer(PresenterSlideView);